import * as React from "react";

type AsideCardProps = {
  title: string;
  children: React.ReactNode;
};

export function AsideCard({ title, children }: AsideCardProps) {
  return (
    <div className="card">
      <div className="card-title">{title}</div>
      <div className="card-body">{children}</div>
    </div>
  );
}
